import React, { memo } from 'react';
import BondSectionTemplate from '@components/BondDirectoryFeature/feature/BondDetails/components/BondSectionTemplate';
import { Text } from '@ui/atoms';
import { cn } from '@ui/atoms/utils/utils';
import texts from '@components/BondDirectoryFeature/feature/BondDetails/en.json';

const RiskAssessment = ({ riskDetails }) => {
    return (
        <BondSectionTemplate
            title={texts?.riskAssessment}
            description={texts?.creditRating}
            className='pt-6 border-b-0'
        >
            <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-2">
                {riskDetails?.map(
                    ({ label = '', value = '', className }, index) => (
                        <div
                            key={index}
                            className={cn('flex gap-1 flex-col', className)}
                        >
                            <Text
                                content={label}
                                className="text-gray-500 p5-regular"
                            />
                            <Text
                                content={value}
                                className="p4-medium text-primary-500"
                            />
                        </div>
                    )
                )}
            </div>
        </BondSectionTemplate>
    );
};

export default memo(RiskAssessment);
